/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface ReorderProductsDto
 */
export interface ReorderProductsDto {
  _id?: string;
    /**
     * The container (category or subcategory) ID
     * @type {string}
     * @memberof ReorderProductsDto
     */
    containerId: string;
    /**
     * The type of container
     * @type {string}
     * @memberof ReorderProductsDto
     */
    containerType: ReorderProductsDtoContainerTypeEnum;
    /**
     * Array of product IDs in the desired order
     * @type {Array<string>}
     * @memberof ReorderProductsDto
     */
    orderedProductIds: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum ReorderProductsDtoContainerTypeEnum {
    Category = 'category',
    Subcategory = 'subcategory'
}

